
import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Spinner } from '@/components/Spinner';

const PageTransition: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const forceCompletionRef = useRef<NodeJS.Timeout | null>(null);
  
  useEffect(() => {
    // Clean up function to clear all timeouts
    const cleanupTimeouts = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      if (forceCompletionRef.current) {
        clearTimeout(forceCompletionRef.current);
        forceCompletionRef.current = null;
      }
    };
    
    // Handle page transition start
    const handleStart = () => {
      setIsLoading(true);
      setError(null);
      
      // Scroll to top of page on navigation
      window.scrollTo(0, 0);
      
      // Set shorter timeout to avoid infinite loading (500ms)
      timeoutRef.current = setTimeout(() => {
        setIsLoading(false);
      }, 500);
      
      // Backup timeout for additional safety
      forceCompletionRef.current = setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    };

    // Handle page transition complete
    const handleComplete = () => {
      // Small delay to avoid flickering
      const timer = setTimeout(() => {
        setIsLoading(false);
        cleanupTimeouts();
      }, 300);
      
      return () => clearTimeout(timer);
    };

    // Simulate loading start when URL changes
    handleStart();
    
    // Simulate loading complete
    handleComplete();

    // Cleanup on unmount or when location changes
    return () => {
      setIsLoading(false);
      cleanupTimeouts();
    };
  }, [location.pathname]); // Only depend on pathname to avoid recursive renders

  if (!isLoading) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-1 z-50">
      <div className="h-full bg-vegana-primary animate-pulse"></div>
    </div>
  );
};

export default PageTransition;
